import { CANDIDATE_STAGES, STRENGTH_LABELS } from './constants';

export function generateSnapshot(role, candidates) {
  const pq = role.pipeline_quality || {};
  const strength = STRENGTH_LABELS[pq.strength] || 'Unknown';
  const topCandidates = [...candidates].sort((a, b) => (b.fit_score || 0) - (a.fit_score || 0)).filter(c => c.fit_score >= 20).slice(0, 5);
  const submitted = candidates.filter(c => c.in_submission);
  const stageMap = {};
  candidates.forEach(c => { const s = c.stage || 'sourced'; stageMap[s] = (stageMap[s] || 0) + 1; });

  let text = '';
  text += `CANDIDATE PIPELINE SUMMARY\n`;
  text += `${'='.repeat(40)}\n\n`;

  text += `Role: ${role.title}\n`;
  text += `Company: ${role.company}\n`;
  if (role.location) text += `Location: ${role.location}\n`;
  text += `Pipeline Status: ${strength}\n`;
  text += `Average Candidate Quality: ${pq.avg_score || 0}/100\n\n`;

  if (topCandidates.length > 0) {
    text += `TOP CANDIDATES\n`;
    text += `${'-'.repeat(40)}\n`;
    topCandidates.forEach((c, i) => {
      text += `\n${i + 1}. ${c.name}\n`;
      text += `   ${c.title}`;
      if (c.current_company) text += ` at ${c.current_company}`;
      text += `\n`;
      if (c.location) text += `   Location: ${c.location}\n`;
      text += `   Match Quality: ${c.fit_score >= 50 ? 'Strong' : c.fit_score >= 30 ? 'Good' : 'Moderate'} (${c.fit_score}/100)\n`;
      const reasons = (c.fit_reasons || []).filter(r => !r.includes('bonus') && !r.includes('keyword')).slice(0, 2);
      if (reasons.length > 0) text += `   Key Strengths: ${reasons.map(r => r.replace(/_/g, ' ').replace(/\(.*?\)/g, '').trim()).join(', ')}\n`;
    });
    text += `\n`;
  }

  text += `PIPELINE OVERVIEW\n`;
  text += `${'-'.repeat(40)}\n`;
  text += `Total Candidates: ${candidates.length}\n`;
  text += `  Strong Match: ${pq.high_fit || 0}\n`;
  text += `  Good Match: ${pq.medium_fit || 0}\n`;
  text += `  Moderate: ${pq.low_fit || 0}\n`;

  const stageEntries = CANDIDATE_STAGES.filter(s => stageMap[s.value] > 0);
  if (stageEntries.length > 0 && !(stageEntries.length === 1 && stageEntries[0].value === 'sourced')) {
    text += `\nCandidate Status:\n`;
    stageEntries.forEach(s => { text += `  ${s.label}: ${stageMap[s.value]}\n`; });
  }

  if (submitted.length > 0) {
    text += `\nSUBMISSION SHORTLIST\n`;
    text += `${'-'.repeat(40)}\n`;
    submitted.forEach((c, i) => {
      text += `${i + 1}. ${c.name} — ${c.title}`;
      if (c.current_company) text += ` at ${c.current_company}`;
      if (c.location) text += ` (${c.location})`;
      text += `\n`;
    });
  }

  text += `\n${'='.repeat(40)}\n`;
  text += `Generated: ${new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}\n`;

  return text;
}
